export default function changeCities() {
    const stateElement = document.getElementById("state");
    const citiesUrlElement = document.getElementById("citiesUrl");

    if (stateElement && citiesUrlElement) {
        stateElement.addEventListener('change', function () {
            const url = citiesUrlElement.value;
            const stateValue = stateElement.value;
            fetch(url, {
                method: 'POST',
                headers: {
                    'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                },
                body: `state=${stateValue}`,
            })
            .then(async (response) => {
                if (!response.ok) {
                    if (response.status === 419) {
                        alert("Sessão expirada. A página será recarregada.");
                        location.reload();
                        return;
                    }

                    const responseText = await response.text();
                    console.error(`Erro HTTP ${response.status}:`, responseText);
                    return;
                }

                return response.text();
            })
            .then(html => {
                const cityElement = document.getElementById("city");
                if (cityElement) {
                    cityElement.innerHTML = html;
                }
            })
            .catch(error => {
                console.error("Error fetching cities:", error);
            });
        });

    }
}
